import { Typography, Box, Button, CircularProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { openSnackBar } from "../../../../../actions/snack-bar"
import { updateCrewStatusCall } from "../../../../../actions/billing"
import moment from "moment"
import useStyles from "./styles"
import React, { Fragment, useState } from "react"
import { toggleClickConfirmationDialog } from "../../../../../actions/billingDialogs"
import GreenButton from "../../../Common/GreenButton/index"
import useBillingDisabled from "../../../../../hooks/useBillingDisabled"
import CopyLinkButton from "../../../Common/CopyLinkButton/index"

const ButtonsComponent = ({ position }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [sendLoading, setSendLoading] = useState(false)
  const [approveLoading, setApproveLoading] = useState(false)

  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const isDisabled = useBillingDisabled()

  let showSendButton =
    position.user_status === "unsent" ||
    position.user_status === "sent" ||
    position.user_status === "rejected" ||
    position.user_status === "available"

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  // *** SEND BILL APPROVAL   ***

  const sendBillApproval = (data, shootRoleId, status) => {
    let dataToUPdateDetails = { requested: 1, available: 1, bill_requested: 1 }

    setSendLoading(true)
    dispatch(
      updateCrewStatusCall(
        data,
        shootRoleId,
        status,
        position.shoot_id,
        position.user_id,
        dataToUPdateDetails
      )
    )
      .then(() => {
        setSendLoading(false)
        dispatch(
          openSnackBar({
            message: "Email Sent",
          })
        )
      })
      .catch(err => {
        console.log(err)
        setSendLoading(false)

        dispatch(
          openSnackBar({
            message: "Error sending email",
          })
        )
      })
  }

  const sendConfirmDialog = () => {
    let sendData = {
      action: "update-status-bill-requested",
    }
    let data = {
      action: "send bill approval to this crew member",
      confirmationFunc: sendBillApproval,
      funcArgs: [
        sendData,
        position.shoot_role || position.id,
        "bill_requested",
      ],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }

  // *** SEND BILL APPROVAL END   ***

  // *** APPROVE MEMBER   ***

  const approveCrewMember = (data, shootRoleId, action) => {
    let dataToUPdateDetails = {
      requested: 1,
      available: 1,
      bill_requested: 1,
      bill_accepted: 1,
      approved: 1,
    }

    setApproveLoading(true)
    dispatch(
      updateCrewStatusCall(
        data,
        shootRoleId,
        action,
        position.shoot_id,
        position.user_id,
        dataToUPdateDetails
      )
    )
      .then(() => {
        setApproveLoading(false)
        dispatch(
          openSnackBar({
            message: "Crew bill approved",
          })
        )
      })
      .catch(err => {
        console.log(err)
        setApproveLoading(false)
        dispatch(
          openSnackBar({
            message: "Error approving crew bill",
          })
        )
      })
  }

  const confirmApproveDialog = () => {
    // repace siganture of accepted person with admin who APPROVES this

    let approveData = {
      action: "update-status-approved",
      bill_approval_signature: `${authenticatedUser.first_name} ${
        authenticatedUser.last_name
      } (Admin)`,
    }
    let data = {
      action: "approve this crew member for this shoot",
      confirmationFunc: approveCrewMember,
      funcArgs: [approveData, position.shoot_role || position.id, "approved"],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }

  // *** APPROVE MEMBER END  ***

  if (!position.first_name && !position.last_name) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        marginLeft="5px"
      />
    )
  } else if (position.user_status === "approved") {
    return (
      <Box
        id="outer"
        display="flex"
        flexWrap="wrap"
        justifyContent="flex-end"
        width={viewportWidth < 600 ? "100%" : "auto"}
        flexDirection={viewportWidth < 600 ? "row" : "column"}
        alignItems={viewportWidth < 600 ? "flex-start" : "flex-end"}
      >
        <Box
          id="inner"
          display="flex"
          flexWrap="wrap"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Typography variant="subtitle1" className={classes.dateText}>
            <span className={classes.acceptedText}>Approved</span>
            {position.bill_approval_signature && (
              <span> by {position.bill_approval_signature}</span>
            )}
            {position.approved_date_time && (
              <span>
                {" "}
                on{" "}
                {moment(position.approved_date_time).format(
                  "M/D/YY[ @ ]h:mm A"
                )}
              </span>
            )}
          </Typography>
        </Box>
      </Box>
    )
  } else if (position.user_id != null) {
    return (
      <Box>
        <Box className={classes.actionButtonWrapper}>
          {showSendButton ? (
            <Button
              variant="outlined"
              color="primary"
              size="small"
              className={classes.sendButton}
              onClick={sendConfirmDialog}
              disabled={isDisabled || sendLoading}
            >
              {sendLoading ? (
                <CircularProgress
                  style={{ alignSelf: "center" }}
                  size={viewportWidth < 600 ? 15 : 20}
                />
              ) : (
                <Typography variant="button" className={classes.buttonText}>
                  Send Bill Approval
                </Typography>
              )}
            </Button>
          ) : (
            // </Box>
            <Box display="flex" mb={1}>
              {position.user_status === "bill_requested" && (
                <Fragment>
                  <Typography
                    textAlign="right"
                    variant="subtitle1"
                    className={classes.dateText}
                  >
                    <span className={classes.sentText}>Sent</span> on{" "}
                    {moment(position.bill_requested_date_time).format(
                      "M/D/YY[ @ ]h:mm A"
                    )}
                  </Typography>
                </Fragment>
              )}
              {position.user_status === "bill_accepted" && (
                <Fragment>
                  <Typography
                    textAlign="right"
                    variant="subtitle1"
                    className={classes.dateText}
                  >
                    <span className={classes.acceptedText}>Accepted</span>
                    {position.bill_approval_signature && (
                      <span> by {position.bill_approval_signature}</span>
                    )}
                    {position.bill_accepted_date_time && (
                      <span>
                        on{" "}
                        {moment(position.bill_accepted_date_time).format(
                          "M/D/YY[ @ ]h:mm A"
                        )}
                      </span>
                    )}
                  </Typography>
                </Fragment>
              )}
            </Box>
          )}
          <Box marginLeft="5px">
            <GreenButton
              variant="outlined"
              disabled={isDisabled || approveLoading}
              onClick={() => confirmApproveDialog()}
              className={classes.approveButton}
              size="small"
            >
              {approveLoading ? (
                <CircularProgress
                  style={{
                    alignSelf: "center",
                    color: "inherit",
                  }}
                  size={viewportWidth < 600 ? 15 : 20}
                />
              ) : (
                <Typography variant="button" className={classes.buttonText}>
                  Approve
                </Typography>
              )}
            </GreenButton>
          </Box>
        </Box>
      </Box>
    )
  }
}

ButtonsComponent.propTypes = {
  position: PropTypes.object,
}

export default ButtonsComponent
